import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'
import AppleLogin from 'react-apple-login'

import { useGoogleLogin } from '@react-oauth/google'

import { AuthHeader } from 'components/ui/AuthHeader'
import { AuthItem } from 'components/ui/AuthItem'
import { AuthContent } from 'components/ui/AuthContent'
import { AuthRow } from 'components/ui/AuthRow'
import { AuthCol } from 'components/ui/AuthCol'
import { Button } from 'components/ui/Button'
import { WhyNeedAccount } from 'components/WhyNeedAccount'

import { authApi, profileApi, callApi } from 'api'

import { setIsPro, logIn } from 'store/actions'

import redirectOnLogin from 'utils/redirectOnLogin'

const LoginPage = (props) => {
  const history = useHistory()
  const data = props?.location?.state

  const responseGoogle = (res) => {
    authApi
      .googleLogInUser({
        code: res?.code,
        redirect_uri: window.location.href,
      })
      .then(async (res) => {
        if (res?.result?.access_token) {
          props.setIsPro(false)
          localStorage.setItem('token', res?.result.access_token)
          localStorage.setItem('refreshToken', res?.result.refresh_token)
          localStorage.setItem('isPro', false)
          await profileApi.getUserInfo().then((res) => props.logIn(res?.result?.profile))
          data?.callDetails || data?.event
            ? callApi.sendCallRequest(data.callRequest).then((res) =>
                res?.result?.redirect
                  ? history.push('/user/callback', res?.result?.call_info)
                  : history.push('/user/payments', {
                      ...data,
                      call_id: res?.result?.call_info,
                    })
              )
            : redirectOnLogin(history)
        }
      })
  }

  const login = useGoogleLogin({
    flow: 'auth-code',
    redirect_uri: window.location.href,
    scope:
      'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid https://www.googleapis.com/auth/contacts.readonly',
    onSuccess: responseGoogle,
    onError: (error) => console.error('Login Failed:', error),
  })

  useEffect(() => {
    document.title = 'TalkPro | Login'
  }, [history, props])

  useEffect(() => {
    let code = [...new URLSearchParams(window.location.search)]
      .find(([key]) => key === 'code')?.[1]
      .toString()

    if (code) {
      authApi.appleLogInUser({ code: code }).then(async (res) => {
        props.setIsPro(false)
        localStorage.setItem('token', res?.result?.access_token)
        localStorage.setItem('refreshToken', res?.result?.refresh_token)
        localStorage.setItem('isPro', false)
        localStorage.setItem('login-method', 'apple')
        await profileApi.getUserInfo().then((res) => {
          props.logIn(res?.result?.profile)
          if (res?.result?.profile) {
            redirectOnLogin(history)
          }
        })
      })
    }
  }, [history, props])

  return (
    <AuthRow>
      <AuthCol type="gradient" />
      <AuthCol>
        <AuthHeader title="Login to your meeting" offsetMod />
        <AuthItem variant="divider">
          <AuthContent>
            You don’t need to remember an email and password, <br /> plus we’ll send you a
            reminders before your talk
          </AuthContent>
        </AuthItem>
        <AuthItem variant="divider">
          <AuthItem>
            <Button
              variant="secondary"
              iconName="google"
              fullWidth
              onClick={() => login()}
            >
              Continue with Google
            </Button>
          </AuthItem>
          <AuthItem>
            <AppleLogin
              clientId="com.talkpro.login"
              redirectURI="https://www.talkpro.com/user/login"
              render={(props) => {
                return (
                  <Button
                    variant="secondary"
                    iconName="apple_white"
                    onClick={props.onClick}
                    fullWidth
                  >
                    Continue with Apple
                  </Button>
                )
              }}
            />
          </AuthItem>
        </AuthItem>
        <AuthItem variant="divider">
          <WhyNeedAccount />
        </AuthItem>
      </AuthCol>
    </AuthRow>
  )
}

const mapStateToProps = ({ auth: { error, attributes } }) => ({
  authError: error,
  attributes,
})

const willMapDispatchToProps = {
  setIsPro,
  logIn,
}

export default connect(mapStateToProps, willMapDispatchToProps)(LoginPage)
